module.exports = __webpack_public_path__ + "static/media/bookmark.3080809a.svg";